import styled from "styled-components";

const Dropdown = styled.div`
  position: relative;
  display: inline-block;
  margin-right: 50px;
  font-size: 20px;
  color: white;

  &:hover {
    div {
      display: block;
    }
    cursor: pointer;
  }
`;

export const DropdownIcon = styled.img`
  position: relative;
  width: 16px;
  top: 3px;
  margin-right: 5px;
  margin-left: 20px;
`;
export const DropdownText = styled.p`
  display: inline-block;
  color: white;
  line-height: 0px;
  margin-left: 15px;
`;

export default Dropdown;
